import { LitElement, html, css } from 'lit'
import { property, customElement } from 'lit/decorators.js'
import '@maersk-global/mds-components-core/mc-modal'

@customElement('voy-error-popup')
export class VoyErrorPopup extends LitElement {
    @property({ type: Boolean, reflect: true }) shown: boolean = false
    @property({ reflect: true }) header: string = ""
    @property({ reflect: true }) content: string = ""
    
    static get styles() {
        return [
            css`
                :host {
                    font-family: MaerskText;
                }

                .title {
                    margin-top: 0px;
                    font-family: MaerskText;
                }

                .footer {
                    text-align: end;
                    padding: 16px 24px;
                    margin: 24px -24px -24px -24px;
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    padding: 16px 24px;
                    gap: 12px;
                    background: #f7f7f7;
                    border-bottom-left-radius: 6px;
                    border-bottom-right-radius: 6px;
                }

                .content {
                    font-family: MaerskText;
                    font-size: 16px;
                }

            `,
        ]
    }

    render() {
        return html`
            <mc-modal
                heading=${this.header}
                ?open=${this.shown}
                dimension="small"
                width="443px"
                height="auto"
                hiddenfooter
                backdropcloseactiondisabled
                escapecloseactiondisabled
                entercloseactiondisabled
                hiddenclose
            >
                <div class="content">
                    ${this.content}
                </div>
                <div class="footer">
                    <mc-button
                        focusstartanchor
                        appearance="primary"
                        variant="filled"
                        @click="${this._onOkay}"
                        >Okay</mc-button
                    >
                </div>
            </mc-modal>
        `
    }

    private _onOkay() {
        this.dispatchEvent(new Event('close'))
    }
}
